module.exports = __webpack_public_path__ + "img/virusColectivo5.5f0ae5f3.jpg";